<template>
  <div class="flex items-center gap-12 py-8" role="separator" :aria-label="`Messages from ${dateLabel}`">
    <span class="flex-1 border-t-1 border-solid border-grey-divider-subdued" />
    <span class="text-caption text-grey-text-subdued shrink-0">{{ dateLabel }}</span>
    <span class="flex-1 border-t-1 border-solid border-grey-divider-subdued" />
  </div>
</template>

<script lang="ts">
export default {
  name: 'MessageListDayDivider',
  props: {
    dateLabel: {
      type: String,
      required: true,
    },
  },
};
</script>
